import * as types from "../types";
import { ActionsCreators } from "..";
import { requestAuth, axiosAuth } from "../../helpers/FetchApi";
import appSettings from "../../AppSettings";
import { toast } from "react-toastify";
import strings from "../../helpers/Localization";
import axios from "axios";
import { GetDefaultContentLangs, GetDefaultTranslations } from "../../helpers/Language";
import { reportError } from "../../helpers/FetchApi";
import { format } from "date-fns";
import { TagFacesOutlined } from "@mui/icons-material";

export const actionCreators = {

    SaveTemporaryDocument: (file, onSuccess, onError) => (dispatch, store) => {
        const formData = new FormData();
        formData.append("document", file);

        axiosAuth(appSettings.SKALINKAPIURL + "/api/Carousel/SaveTemporaryDocument/" + store().currentuser.currentorganization.id,
            {
                method: "POST",
                data: formData
            }
        )
            .then(function (response) {
                onSuccess(response.data.result);
            })
            .catch(function (error) {
                if (onError) {onError();}
            });
    },

    EditCarousel: (carouselObject, onSuccess, onError) => async (dispatch, store) => {
        const body = { ...carouselObject };

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Carousel/" + store().currentuser.currentorganization.id, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body),
            method: "PUT"
        }).then((data) => {
            toast.success(strings.SaveChanges);
            return onSuccess(data);
        }).catch((error) => {
            console.log("error", error);
            if (onError) {onError(error);}
        });
    },

    GetCarousel: (onSuccess, onError) => async (dispatch, store) => {
        requestAuth(appSettings.SKALINKAPIURL + "/api/Carousel/" + store().currentuser.currentorganization.id, {
            method: "GET"
        }).then((data) => {
            return onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    GetCarouselReporting: (onSuccess, onError) => async (dispatch, store) => {
        requestAuth(appSettings.SKALINKAPIURL + "/api/Carousel/GetReporting/" + store().currentuser.currentorganization.id, {
            method: "GET"
        }).then((data) => {
            return onSuccess(data);
        }).catch( (error) => {
            console.log("error", error);
            return onError(error);
        });
    }
};
